import React from "react";

import BlogEventLayout from "../components/blogLayoutComp";
import SEO from "../components/seo";

import mainImg from "../images/linkedinEvent.jpeg";

import ReactGA from 'react-ga';

ReactGA.initialize('UA-178007415-1');

//ReactGA.pageview(window.location.pathname + window.location.search);

function EventsBlogDetailsPage() {

  React.useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <BlogEventLayout
      title="How To Utilize LinkedIn Effectively - A Workshop on LinkedIn Profile Building"
      brief=" The importance of having a stellar LinkedIn profile can never be overstated. Leveraging LinkedIn with the right intent can help you build your network, showcase your skills and expertise, and even help you land your dream job or further your pursuit of higher education."
      heading1 = "LinkedIn - An Overview"
      breif1 = "LinkedIn is primarily used for networking and job search, and the impact LinkedIn has is well known. Even though the content on LinkedIn is seen as super-formal, and the platform is noticeably different from other social media platforms, navigating through this shouldn’t be a tough act."
      heading2 = "Optimizing Your LinkedIn Profile"
      imageMain={mainImg}
      extraContent =
      {
      <div>
        <div className="container mx-auto flex flex-wrap pt-4 pb-12" id="programs">

            <h3 className="w-full my-2 text-3xl font-bold leading-tight text-center" >Benefits Of LinkedIn</h3>
            <div className="w-full mb-4">
              <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
            </div>

            <div className="w-full md:w-1/3 p-8 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
                <a href="#" className="flex flex-wrap no-underline hover:no-underline">
                  {/* <p className="w-full text-gray-600 text-xs md:text-sm px-6">
                  </p> */}
                  <div className="w-full font-bold text-xl text-gray-800 px-2 py-4 text-center">LinkedIn - Do’s and Don’ts</div>
                    <p className="text-gray-800 text-base px-4 mb-5">
                        <li>
                          Curate your responses and communication. Do not comment randomly on 
                          posts on your feed. Your communication must be relevant, and insightful.
                        </li>
                        <li>
                          Commenting “Interested”, “Commenting for better reach” doesn’t work most 
                          of the time, and it doesn’t contribute to your value addition on the platform.
                        </li>
                        <li>
                          Curate your connection requests, and send requests to people you know. 
                          Having a relevant list of connections is more beneficial than having a huge 
                          number of irrelevant connections.
                        </li>
                        <li>
                          Keep your communication professional. LinkedIn is a 
                          platform for professionals after all. 
                        </li>
                    </p>
                </a>
              </div>
            </div>

            <div className="w-full md:w-1/3 p-8 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
                <a href="#" className="flex flex-wrap no-underline hover:no-underline">
                  {/* <p className="w-full text-gray-600 text-xs md:text-sm px-6">
                  </p> */}
                  <div className="w-full font-bold text-xl text-gray-800 px-2 py-4 text-center">Leveraging LinkedIn In College</div>
                    <p className="text-gray-800 text-base px-4 mb-5">
                        <li>
                          Follow influencers and content creators who are relevant in your domain. 
                        </li>
                        <li>
                          Message experts if you are curious about something 
                          and start catching attention early on. 
                        </li>
                        <li>
                          Start connecting with “relevant” folks. 
                          Add a note when you send a connection request.
                        </li>
                        <li>
                          Search for jobs on career portals or on LinkedIn and cold 
                          message your connections (recent ones/ BMSCE alumni if possible). 
                        </li>
                        <li>
                          Applying through referrals always have higher chances
                          of catching the recruiters’ attention.
                        </li>
                    </p>
                </a>
              </div>
            </div>

            <div className="w-full md:w-1/3 p-8 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
                <a href="#" className="flex flex-wrap no-underline hover:no-underline">
                  {/* <p className="w-full text-gray-600 text-xs md:text-sm px-6">
                  </p> */}
                  <div className="w-full font-bold text-xl text-gray-800 px-2 py-4 text-center">Choosing Your Post-Grad Stream, and Networking</div>
                    <p className="text-gray-800 text-base px-4 mb-5">
                        <li>
                          Explore different streams related to your career path, reach out to professors 
                          from universities to know more about what they do
                        </li>
                        <li>
                          Reach out to current students pursuing their Masters programs, 
                          and get a better picture about the course, the student culture, and the university.
                        </li>
                        <li>
                          Connect with professors doing research on topics you’re interested 
                          in - Build a relationship which can help you when you eventually pursue your course
                        </li>
                        <li>
                         Get recommendations from your professors and project guides!
                        </li>
                    </p>
                </a>
              </div>
            </div>
            </div>
            <section class="bg-white border-b py-8 px-8 text-gray-800">
            <div class="container max-w-5xl mx-auto m-8">
              <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">Supercharge Your Job Search With LinkedIn</h2>
              <div class="flex flex-wrap -mx-4 overflow-hidden text-gray-600">

                <div class="my-4 px-4 w-1/3 overflow-hidden ">
                  Searching for relevant jobs is easy on LinkedIn, as the platform analyzes your profile, your interests and shows you jobs based on your expectations. Update your preferences, and get the most relevant opportunities
                </div>

                <div class="my-4 px-4 w-1/3 overflow-hidden ">
                  Reach out to suitable people in companies - Know what your future job might entail, know the company culture and more
                </div>

                <div class="my-4 px-4 w-1/3 overflow-hidden ">
                  Follow companies on LinkedIn , engage with their posts, start a conversation , score brownie points.<br/>
                  <a style={{color: "blue"}} href="https://premium.linkedin.com/content/premium/global/en_us/index/jobsearch">LinkedIn Premium</a> can help you analyze your performance, know if recruiters are looking into your profile, get data about other applicants and more. 
                </div>

              </div>
            </div>
          </section>
          
          <section class="bg-purple border-b py-8 px-8 ">
            <div class="container max-w-5xl mx-auto m-8">
              <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">Stand Out From The Crowd - LinkedIn for Building Relationships</h2>
              <div class="flex flex-wrap -mx-4 overflow-hidden">

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                  Apply to jobs on company job portals, and network with stakeholders and recruiters in the company on LinkedIn
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                  Use InMails to reach out to recruiters with personal messages, boost your chances of getting hired.
                  Don’t hesitate to message job posters.
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                  Connect with employees or alumni to get referrals. Job applications through referrals have a significantly better chance of being hired<br/>
                </div>
                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                  Reach out with a personalized email, a brief description of your skills, why you’d be a good fit for the role and the company. Don’t forget to send in your resume.
                </div>
              </div>
            </div>
          </section>
      </div>
            
      }

    blogVideoSrc=""
    >
    
      <SEO
        title="Events:BMSCE Alumni Club"
        keywords={[`bmsce`, `alumni`, `club`, `getscrewed`]}
      />

    </BlogEventLayout>
  );
}

export default EventsBlogDetailsPage;
